import script from "./WarningTextBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./WarningTextBlock.vue?vue&type=script&lang=ts&setup=true"

import "./WarningTextBlock.vue?vue&type=style&index=0&id=320a1938&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TelAvivMuseum.Web\\museum-telaviv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-320a1938"]])

export default __exports__